export const data = [
    {
        title: 'featuresPopup:plan_limits_popup:blog',
        value: 'featuresPopup:plan_limits_popup:articles',
        amount: 10,
    },
    {
        title: 'featuresPopup:plan_limits_popup:cloud',
        value: 'featuresPopup:plan_limits_popup:links',
        amount: 5,
    },
    {
        title: 'featuresPopup:plan_limits_popup:map',
        value: 'featuresPopup:plan_limits_popup:location',
        amount: 1,
    },
    {
        title: 'featuresPopup:plan_limits_popup:surveys',
        value: 'featuresPopup:plan_limits_popup:survey_per_month',
        amount: 1,
    },
    {
        title: 'featuresPopup:plan_limits_popup:ebook',
        value: 'featuresPopup:plan_limits_popup:per_document',
        amount: 20,
    },
]
